import { render } from "./AIReport.vue?vue&type=template&id=4057a8c0&scoped=true"
import script from "./AIReport.vue?vue&type=script&lang=js"
export * from "./AIReport.vue?vue&type=script&lang=js"

import "./AIReport.vue?vue&type=style&index=0&id=4057a8c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4057a8c0"]])

export default __exports__